import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { tokens, HEADING_FONT } from '../../theme';
import logo from '../../assets/img/logo-2-white.png';
import trucks from '../../assets/img/trucks.png';

// Shared frame for sign-in, forgot password and reset password.
const AuthLayout = ({ title, subtitle, children }) => (
    <Box sx={{ minHeight: '100vh', display: 'flex', bgcolor: 'background.default' }}>
        <Box
            sx={{
                display: { xs: 'none', md: 'flex' },
                flexDirection: 'column',
                justifyContent: 'space-between',
                width: 440,
                flexShrink: 0,
                bgcolor: tokens.navy,
                color: '#fff',
                px: 6,
                pt: 6,
                overflow: 'hidden',
            }}
        >
            <Box>
                <Box sx={{ bgcolor: '#fff', borderRadius: 1.5, px: 2.5, py: 1.5, display: 'inline-flex' }}>
                    <img src={logo} alt="All City Towing" style={{ height: 64 }} />
                </Box>
                <Typography
                    sx={{ fontFamily: HEADING_FONT, fontSize: '2.25rem', fontWeight: 600, lineHeight: 1.15, mt: 6 }}
                >
                    Vendor portal
                </Typography>
                <Typography sx={{ color: tokens.sidebarText, mt: 1.5, maxWidth: 320, lineHeight: 1.6 }}>
                    Request tows, follow active calls on the map, and pull invoices, reports and tow sheets for your
                    agency.
                </Typography>
            </Box>
            <Box component="img" src={trucks} alt="" sx={{ width: '115%', ml: -3, display: 'block', opacity: 0.9 }} />
        </Box>

        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: { xs: 2, sm: 4 } }}>
            <Box sx={{ width: '100%', maxWidth: 420 }}>
                <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'center', mb: 3 }}>
                    <img src={logo} alt="All City Towing" style={{ height: 64 }} />
                </Box>
                <Paper variant="outlined" sx={{ p: { xs: 3, sm: 4 } }}>
                    <Typography variant="h4" component="h1">
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography color="text.secondary" sx={{ mt: 0.75, mb: 3 }}>
                            {subtitle}
                        </Typography>
                    )}
                    {!subtitle && <Box sx={{ mb: 3 }} />}
                    {children}
                </Paper>
            </Box>
        </Box>
    </Box>
);

export default AuthLayout;
